// A branch name as cortex accepts it (git's rules, the api's pattern).
/** Mirrors the API's branch rule so the form says no before the server does. */
export const BRANCH_NAME = /^[A-Za-z0-9][A-Za-z0-9._-]*(\/[A-Za-z0-9][A-Za-z0-9._-]*)*$/;
export const isValidBranchName = (n: string) =>
  n.length <= 100 && BRANCH_NAME.test(n) && !n.includes('..') && !n.endsWith('.lock') && !n.endsWith('.');
